import { render, staticRenderFns } from "./NoticeOfVariationInPartnershipTerms.vue?vue&type=template&id=dac6448e&scoped=true&"
import script from "./NoticeOfVariationInPartnershipTerms.vue?vue&type=script&lang=js&"
export * from "./NoticeOfVariationInPartnershipTerms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dac6448e",
  null
  
)

export default component.exports